export default class Endereco {
    constructor(cep = '', logradouro = '', complemento = '', bairro = '', cidade = '', estado = '') {
        this.cep = cep;
        this.logradouro = logradouro;
        this.complemento = complemento;
        this.bairro = bairro;
        this.cidade = cidade;
        this.estado = estado;
    }
}


// WEBPACK FOOTER //
// ./src/domain/cep/Endereco.js